import { PrimaryText } from "@/components/Typography/Styled";

import { StyledEmptySalesResultContainer } from "./Styled";

export const EmptySalesResult = () => {
    return (
        <StyledEmptySalesResultContainer>
            <PrimaryText
                fontSize={16}
                fontWeight="400"
                style={{ textAlign: "center" }}
            >
                За поданий період історія продажів не знайдена
            </PrimaryText>
        </StyledEmptySalesResultContainer>
    );
};
